import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const NotFound = () => {
  return (
    <Box>
      <Box
        sx={{
          height: 300,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Typography>Page Not Found</Typography>
      </Box>
    </Box>
  );
};

export default NotFound;
